import { Pipe, PipeTransform } from '@angular/core';
import { AppTableColumn } from '../_models/models';

export interface CellTag {
  text: string;
  class: string;
}

@Pipe({
  name: 'cellTag'
})
export class CellTagPipe implements PipeTransform {
  transform(row: any, column: AppTableColumn): CellTag | null {
    const tagConfig = column?.tagConfig;
    if (!tagConfig || tagConfig.checkFn?.(row) === false) {
      return null;
    }
    return { text: this.resolve(tagConfig.tagText, row), class: this.resolve(tagConfig.tagClass, row) };
  }

  private resolve(value: string | ((row: any) => string), row: any): string {
    return typeof value === 'function' ? value(row) : value;
  }
}
